// Angular
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
// Environment
import { environment } from '@environment';
// Module
import { NgxLoadingBar } from '@ngx-loading-bar/core';
// Components
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgxLoadingBar, HeaderComponent, RouterOutlet, FooterComponent],
})
export class LayoutComponent {
  // Public
  flags: any = environment?.featureFlags;
}
